import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { QuotesService } from '@services/http/quotes.service';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-quote-stepper',
  templateUrl: './quote-stepper.component.html',
  styleUrls: ['./quote-stepper.component.scss'],
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatStepperModule, FlexLayoutModule]
})
export class QuoteStepperComponent {
  _quotesService: QuotesService = inject(QuotesService);
  @Input() stepperTitle: string;

  stepperSteps: StepDTO[] = [];
  stepperSubject: Observable<StepDTO[]> = this._quotesService.quoteStepperSubject.pipe(
    tap(stepps => (this.stepperSteps = stepps))
  );

  isExnapsionPanelDisabled(step: StepDTO, i: number): boolean {
    if (i === 0) return step.isCompleted;
    if (i === this.stepperSteps.length - 1) return !this.stepperSteps[i - 1].isCompleted;

    return !(
      this.stepperSteps[i - 1].isCompleted === true &&
      this.stepperSteps[i + 1].isCompleted === false &&
      !step.isCompleted
    );
  }

  isStepExpanded(step: StepDTO, i: number): boolean {
    if (i === 0) return !step.isCompleted;
    if (i === this.stepperSteps.length - 1) return this.stepperSteps[i - 1].isCompleted;

    return (
      this.stepperSteps[i - 1].isCompleted === true &&
      this.stepperSteps[i + 1].isCompleted === false &&
      !step.isCompleted
    );
  }

  currentActiveSubstepIndex(step: StepDTO): number {
    const activeSubstep = step.subSteps.find(x => x.isCompleted === false);
    return activeSubstep ? step.subSteps.indexOf(activeSubstep) : step.subSteps.length - 1;
  }

  readonly pxPerLine = 15;

  getStepDescOffsetPx(desc?: string): string {
    if (!desc) return '0px';
    const rows = desc.split('\n').length;
    return `${rows * this.pxPerLine}px`;
  }
}

export class StepDTO {
  isExpanded?: boolean = false;
  stepTitle: string;
  stepDescription: string;
  subSteps: SubStepDTO[] = [];
  isCompleted = false;
}

export class SubStepDTO {
  subStep: string;
  isCompleted = false;
}
